import currency from "currency.js"
import GiftCard from "../documents/GiftCard"
import TicketDetail from "../documents/TicketDetail"
import TicketMaster from "../documents/TicketMaster"

export async function customFetch(method, url, body = null, headers = {}) {
  var options = { method: method, headers: headers }
  if (body) { options.headers["Content-Type"] = "application/json"; options.body = JSON.stringify(body) }
  const response = await fetch(url, options)
  let data = await response.text()
  try { data = JSON.parse(data) } catch (e) { console.log(e) }
  return { response, data }
}

export function getDateByOffset(offset) {
  const date = new Date()
  date.setDate(date.getDate() + offset)
  return date
}

/*
  y = year, m = month, d = day
  ymd = 2024/05/14
  ydm = 2024/14/05
  mdy = 05/14/2024
  yyy = 2024/2024/2024
*/
export function formatDate(date, format) {
  const dt = new Date(date)
  const year = dt.getFullYear()
  const month = (dt.getMonth() + 1).toString().padStart(2, "0")
  const day = dt.getDate().toString().padStart(2, "0")
  return format.split("").map(x => {
    if (x === 'y') return year
    if (x === 'm') return month
    if (x === 'd') return day
    return ""
  }).join("/")
}

export async function createTicketEPN(mid, cash, credit, tax, cardAdminFee, cardAdminFeeTax, discount, tip, items, invoiceNumber, giftcardNumber, callback = () => { }) {
  console.log("STARTING VALOR TRANSACTION...")
  localStorage.removeItem("INCOMING_REF_TXN_ID")
  let retryCount = 0
  const storageInterval = setInterval(() => {
    console.log("CHECKING FOR TRANSACTION RESULT...")
    const REF_TXN_ID = localStorage.getItem("INCOMING_REF_TXN_ID")
    if (REF_TXN_ID) {
      console.log("CREATING TICKET!")
      createTicket(mid, cash, credit, tax, cardAdminFee, cardAdminFeeTax, discount, tip, items, REF_TXN_ID, invoiceNumber, giftcardNumber)
      fetch(`${process.env.REACT_APP_API}/api/invoices/update/${invoiceNumber}?amount=${credit}`)
      callback()
      localStorage.removeItem("INCOMING_REF_TXN_ID")
      clearInterval(storageInterval)
      return
    }
    if (retryCount++ > 180) {
      console.log("TRANSACTION TIMEOUT...")
      clearInterval(storageInterval)
    }
  }, 1000)
}

export function createTicket(mid, cash, credit, tax, cardAdminFee, cardAdminFeeTax, discount, tip, items, transactionID, invoiceNumber, giftcardNumber) {
  const master = new TicketMaster(mid, cash, credit, tax, cardAdminFee, cardAdminFeeTax, discount, tip, "Reef Web", "CLOSED")
  if (transactionID) master.PNRef = transactionID
  if (invoiceNumber) master.invoiceNumber = invoiceNumber
  if (giftcardNumber) master.giftcardNumber = giftcardNumber
  if (items) master.details = items.map(item => new TicketDetail(mid, item))
  fetch(`${process.env.REACT_APP_API}/api/mongo/add-document/TicketMaster`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(master.resolveDocument())
  }).then(() => {
    for (const item of items) {
      // Update inventory quantity
      fetch(`${process.env.REACT_APP_API}/api/mongo/update-document/Item/${item.itemId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ $inc: { quantity: -item.quantity } })
      }).then(() => {
        // Enforce quantity to be greater than or equal to 0
        fetch(`${process.env.REACT_APP_API}/api/mongo/update-document/Item/${item.itemId}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ $max: { quantity: 0 } })
        })
      })
      if (item.isGiftCard) {
        for (let i = 0; i < Number(item.quantity); i++) {
          fetch(`${process.env.REACT_APP_API}/api/mongo/add-document/GiftCard`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(new GiftCard(mid, true, item.giftcardNumbers[i], currency(item.originalCashPrice, { fromCents: true }).value, null, transactionID).resolveDocument())
          })
        }
      }
    }
  })
}

// A function to store any transaction model while also allowing appending custom data.
export function logTransaction(transaction, transactionId, customData = {}) {
  // A lazy fix, but I need this up soon. This prevents storing a value of just "/"
  if (customData.customerName && customData.customerName === "/") delete customData.customerName
  const customTransaction = {
    _id: transactionId,
    user: sessionStorage.getItem("username"),
    ...transaction,
    ...customData
  }
  fetch(`${process.env.REACT_APP_API}/api/mongo/add-document/TransactionLog`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(customTransaction)
  })
}

export async function getTransactionLogs(ids) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API}/api/mongo/get-documents/TransactionLog`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        ignoreMid: true,
        ignoreDeletion: true,
        ignoreActive: true,
        query: { _id: { $in: [...ids] } }
      })
    })
    const data = await response.json()
    return data
  } catch (e) { return [] }
}

export async function getTransactionLog(transactionID) {
  try {
    const response = await fetch(`${process.env.REACT_APP_API}/api/mongo/get-document/TransactionLog/${transactionID}`)
    const data = await response.json()
    return data
  } catch (e) { return null }
}

export function generateReceiptCommands(data) {
  const commands = []
  commands.push(`TEXT_CENTER: ${data.id}`)
  commands.push("FEED_LINE: 1")
  commands.push(`TEXT_CENTER: ${data.name}`)
  commands.push(`TEXT_CENTER: ${data.address}`)
  commands.push(`TEXT_CENTER: ${data.city}, ${data.state} ${data.zip}`)
  commands.push(`TEXT_CENTER: ${data.phone}`)
  commands.push("FEED_LINE: 1")
  commands.push(`TEXT_SPACED: ${data.date}\\\\Device: ${data.device}`)
  commands.push("SPACE_LINE")
  if (data.items && data.items.length) {
    for (const item of data.items)
      commands.push(`TEXT_SPACED: ${item.quantity}    ${item.name}\\\\${item.price}`)
    commands.push("FEED_LINE: 1")
  }
  commands.push(`TEXT_SPACED: SUBTOTAL:\\\\${data.subtotal}`)
  commands.push(`TEXT_SPACED: TAX:\\\\${data.tax}`)
  commands.push(`TEXT_SPACED: TOTAL:\\\\${data.total}`)
  commands.push("SPACE_LINE")
  commands.push(`TEXT_SPACED: PAID:\\\\${data.paid}`)
  commands.push(`TEXT_SPACED: CHANGE:\\\\${data.change}`)
  commands.push("TEXT_CENTER: PAYMENTS")
  commands.push("FEED_LINE: 1")
  for (const payment of data.payments)
    commands.push(`TEXT_SPACED: ${payment.type}:\\\\${payment.amount}`)
  commands.push("FEED_LINE: 3")
  commands.push(`TEXT_CENTER: Items Sold - ${data.items.length}`)
  commands.push("FEED_LINE: 1")
  return commands
}

export function extractTextFromField(field) {
  if (field === undefined) return ""
  if (field._text === undefined) return ""
  return field._text.trim()
}